import { useQuery } from '@tanstack/react-query'
import { z } from 'zod'

import { httpService } from '@/api/v1/http.service'
import { type UserStatus } from '@/types/user-status'

const responseSchema = z.array(
  z.object({
    id: z.string().min(1),
    full_name: z.string().min(1)
  })
)

type StudentOption = {
  label: string
  value: string
}

const parseResponse = (
  response: z.infer<typeof responseSchema>
): StudentOption[] =>
  response.map(item => ({
    value: item.id,
    label: item.full_name
  }))

type Params = {
  semester?: string
  search?: string
  academicLevelId?: string[]
  classId?: string[]
  tutor?: string[]
  parent?: string[]
  status?: UserStatus[]
  groupId?: string
  page?: number
  pageSize?: number
  fetchKeys?: Record<string, boolean>
}

const useStudentOptions = (params: Params = {}) =>
  useQuery({
    queryKey: ['panelStudentOptionsList', params],
    staleTime: 60 * 100,
    queryFn: async () => {
      const response = await httpService.panel.panelStudentsList({
        search: params.search,
        academic_level_id: params.academicLevelId,
        class_id: params.classId,
        tutor_id: params.tutor,
        parent_id: params.parent,
        status: params.status,
        semester_id: params.semester,
        // @ts-expect-error Waits for backend fix
        page_size: params.pageSize || 'max',
        group_id: params.groupId,
        page: params.page,
        fetchKeys: {
          id: true,
          full_name: true
        }
      })
      return parseResponse(responseSchema.parse(response.results))
    },
    placeholderData: previous => previous
  })

export default useStudentOptions
